import React from 'react';
import CheckoutSubheaderEntry from './CheckoutSubheaderEntry';
import { useSelector } from 'react-redux';
import If from './If';
import { skipPayment } from "../utils/configUtils";
import { useLingui } from '@lingui/react/macro';

function CheckoutSubheader(props) {

    const isAgency = useSelector(state => state.agency.isAuthenticated);

    const {t} = useLingui();

    const shouldSkipPayment = skipPayment();

    return (
        <div className="bg-primary text-white uppercase print-hidden">
            <div className="container mx-auto flex justify-start py-4 overflow-hidden">
                {/* header for agency */}
                <If test={isAgency || shouldSkipPayment}>
                    <CheckoutSubheaderEntry
                        active={props.active === "summary"}
                        nr="1"
                        text={t({id: "summary"})}
                        hideOnMobile={false}
                    />
                    <CheckoutSubheaderEntry
                        active={props.active === "confirmation"}
                        nr="2"
                        text={t({id: "confirmation"})}
                        hideOnMobile={false}
                    />
                </If>
                {/* header for customer */}
                <If test={!isAgency && !shouldSkipPayment}>
                    <CheckoutSubheaderEntry
                        active={props.active === "summary"}
                        nr="1"
                        text="Summary"
                        hideOnMobile={props.hideOnMobile === 1}
                    />
                    <CheckoutSubheaderEntry
                        active={props.active === "payment"}
                        nr="2"
                        text="payment"
                        hideOnMobile={props.hideOnMobile === 2}
                    />
                    <CheckoutSubheaderEntry
                        active={props.active === "confirmation"}
                        nr="3"
                        text="confirmation"
                        hideOnMobile={props.hideOnMobile === 3}
                    />
                </If>
            </div>
        </div>
    );
}

export default CheckoutSubheader;